/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyQuetzal = createReactComponent("currency-quetzal", "IconCurrencyQuetzal", [
  ["path", { d: "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", key: "svg-0" }],
  ["path", { d: "M13 13l5 5", key: "svg-1" }]
]);

export { IconCurrencyQuetzal as default };
//# sourceMappingURL=IconCurrencyQuetzal.js.map
